/**
 *	Alle plugins in diesem Verzeichnis automatisch global registrieren.
 * 
 */

import Vue from 'vue'

import Preload from './preload';
Vue.use( Preload );

import HitTest from './hitTest';
Vue.use( HitTest );

